import _get from 'lodash-es/get';
import { connect } from 'react-redux';
import { currentFlowTypeEnum } from '../../common/components/constants';
import { getAllEmployeesInitiate } from '../../../actions/employee';
import GiftingRecipientsTable from './GiftingRecipientsTable';

const mapStateToProps = state => {
  const employeesData = _get(state, 'employees', {});
  const selectedWorkspace = _get(state, 'user.selectedWorkspace', {});
  const viewOnlyMode = _get(state, 'user.view_only_mode', false);
  const currentFlow = currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD;
  return {
    currentFlow,
    viewOnlyMode,
    employeesData,
    selectedWorkspace,
    fetchingEmployees:
      _get(state, 'apiState.GET_EMPLOYEES.isFetching', true) &&
      !_get(state, 'apiState.GET_EMPLOYEES.isIdle', false),
    fetchedEmployees: _get(state, 'apiState.GET_EMPLOYEES.success', true),
  };
};

const mapDispatchToProps = dispatch => ({
  getAllEmployees: payload => dispatch(getAllEmployeesInitiate(payload)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GiftingRecipientsTable);
